import React from 'react';
import {
  Box, Card, CardContent, Container, Grid, Stack, Typography,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { AutocompleteSelect, ZSpinner } from '@marageti/z4-lib';
import { SalesRecordingTotals } from '@marageti/z4-sdk/lib/travel/SalesRecording';
import InvoiceTable from './invoice-table';

type Option = {
  title: string;
  value: string | undefined;
};

type ViewProps = {
  loading: boolean;
  onChangeMonth: (value: Date | null) => void;
  onChangeStatus: (value: Option) => void;
  sales: SalesRecordingTotals[] | [];
  selectedMonth: Date | null;
  selectedStatus: Option
  statusOptions: Option[]
};

const minDate = new Date('2008-01-01T00:00:00');

const InvoiceView = ({
  loading,
  onChangeMonth,
  onChangeStatus,
  sales,
  selectedMonth,
  selectedStatus,
  statusOptions,
}: ViewProps) => (
  <Container maxWidth="xl">
    <Box
      sx={{
        pt: { desktop: 4.5, mobile: 6.5 },
        pb: 20,
        maxWidth: { desktop: 'desktop' },
        margin: { desktop: '0 auto 56px' },
      }}
    >
      <Stack spacing={5}>
        <Stack direction={{ desktop: 'row' }} justifyContent="space-between" alignItems={{ desktop: 'center' }}>
          <Typography variant="h2" sx={{ mb: { mobile: 3, desktop: 'none' } }}>Invoices</Typography>
        </Stack>
        <Grid
          container
          columnSpacing={2}
          sx={{
            width: '100%',
            mt: '0px !important',
          }}
        >
          <Grid item mobile={12} desktop={3} sx={{ pl: '0px !important' }}>
            <DatePicker
              label="Month"
              minDate={minDate}
              onChange={onChangeMonth}
              value={selectedMonth}
              views={['month', 'year']}
              slotProps={{
                textField: {
                  sx: {
                    maxWidth: { desktop: '304px' },
                    width: '100%',
                  },
                  className: 'custom-datePicker',
                },
              }}
            />
          </Grid>
          <Grid
            item
            mobile={12}
            desktop={3}
          >
            <AutocompleteSelect
              key="status-select"
              label="Status"
              name="status-input"
              value={selectedStatus}
              onChange={(e, v) => onChangeStatus(v)}
              options={statusOptions}
            />
          </Grid>
        </Grid>
        {loading ? (
          <Box display="flex" justifyContent="center">
            <ZSpinner />
          </Box>
        ) : null}
        {!loading && sales.length > 0 ? (
          <InvoiceTable
            sales={sales}
            selectedMonth={selectedMonth}
          />
        ) : null}
        {!loading && sales.length === 0 ? (
          <Card>
            <CardContent>
              <Typography variant="body" color="primary.light" textAlign="center">
                There are no sales recordings for the selected month and status.
              </Typography>
            </CardContent>
          </Card>
        ) : null}
      </Stack>
    </Box>
  </Container>
);

export default InvoiceView;
